import FileProviderItemViewState from '../../store/schema/FileProviderItemViewState';
import { OwaDate, getTimestamp } from 'owa-datetime';

// Bug 29926: remove this file and move to OneDrive sorting when available.
export function sortSharedWithMeByName(
    items: FileProviderItemViewState[],
    sortAsc: boolean
): FileProviderItemViewState[] {
    const sortDirection: number = sortAsc ? 1 : -1;
    function compareFileNames(item1: FileProviderItemViewState, item2: FileProviderItemViewState) {
        if (item1.name.toLowerCase() > item2.name.toLowerCase()) {
            return sortDirection;
        } else if (item2.name.toLowerCase() > item1.name.toLowerCase()) {
            return -sortDirection;
        }

        return 0;
    }

    return items.sort(compareFileNames);
}

export function sortSharedWithMeByDateShared(
    items: FileProviderItemViewState[],
    sortAsc: boolean
): FileProviderItemViewState[] {
    const sortDirection: number = sortAsc ? 1 : -1;
    function getTimeInternal(date: OwaDate | null) {
        return date != null ? getTimestamp(date) : 0;
    }

    return items.sort((item1: FileProviderItemViewState, item2: FileProviderItemViewState) => {
        return (
            sortDirection * (getTimeInternal(item1.sharedTime) - getTimeInternal(item2.sharedTime))
        );
    });
}

export function sortSharedWithMeBySharedBy(
    items: FileProviderItemViewState[],
    sortAsc: boolean
): FileProviderItemViewState[] {
    function compareSharedByNames(
        item1: FileProviderItemViewState,
        item2: FileProviderItemViewState
    ) {
        const sortDirection: number = sortAsc ? 1 : -1;

        // We put files with empty sharedBy field at the end regardless of sort order.
        if (!item1.sharedBy) {
            return item2.sharedBy === null ? 0 : 1;
        } else if (!item2.sharedBy) {
            return -1;
        }

        if (item1.sharedBy.toLowerCase() > item2.sharedBy.toLowerCase()) {
            return sortDirection;
        } else if (item2.sharedBy.toLowerCase() > item1.sharedBy.toLowerCase()) {
            return -sortDirection;
        }

        return 0;
    }

    return items.sort(compareSharedByNames);
}
